<template>
  <iframe
    :id="videoId"
    frameborder="0"
    allowfullscreen="yes"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    title="VID 1:1 for aspect ratio"
    width="100%"
    height="100%"
    :src="youtubeUrl"
  ></iframe>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      default: '',
    },
  },
  computed: {
    youtubeUrl() {
      return `https://www.youtube.com/embed/${this.videoId}?showinfo=0&amp;rel=0&amp;modestbranding=0&amp;autoplay=1&amp;mute=0&amp;loop=1&amp;playsinline=1&amp;controls=1&amp;enablejsapi=1&amp;`;
    },
  },
};
</script>
